<i class="far fa-times close" (click)="closeDialog()"></i>
<header class="header" mat-dialog-title>Agregar nuevo archivo</header>

<mat-dialog-content class="dialog-content">
	<form class="form" id="form" [formGroup]="form" (ngSubmit)="saveChanges($event)">
		<div class="wrapper-form-control">
			<label for="level" class="form-label"> Tipo de recurso </label>
			<select class="form-select" formControlName="teacherResourceId"
        [ngClass]="{'is-invalid': hasError('teacherResourceId')}">
				<option *ngFor="let item of resourcesTypes" [value]="item.id">
					{{ item.description }}
				</option>
			</select>
      <div class="invalid" *ngIf="hasError('teacherResourceId')">
        {{getFirstErrorMessage('teacherResourceId')}}
      </div>
		</div>

		<div class="wrapper-form-control">
			<label class="form-label">Nombre</label>
			<input type="text" class="form-control" formControlName="name"
        [ngClass]="{'is-invalid': hasError('name')}"
      />
      <div class="invalid" *ngIf="hasError('name')">
        {{getFirstErrorMessage('name')}}
      </div>
		</div>

		<div class="wrapper-form-control">
			<label class="form-label"> Descripción </label>
			<textarea class="form-control" rows="3" formControlName="description"
        [ngClass]="{'is-invalid': hasError('description')}">
      </textarea>
      <div class="invalid" *ngIf="hasError('description')">
        {{getFirstErrorMessage('description')}}
      </div>
		</div>

    <button class="btn btn-outline-primary btn-lg rounded-pill"
			type="button"
			[ngClass]="{'btn-outline-danger': hasError('file')}"
			(click)="file.click()">
      <i class="fa fa-link"></i>
      Adjuntar archivo
    </button>

    <input hidden type="file" #file [accept]="acceptMultimedia" (change)="changeFile($event)">
    <span class="fileName">{{fileName || 'No  seleccionado'}}</span>
		<div class="progress">
			<div class="progress-bar progress-bar-primary"
				[style.width]="progress + '%'">
				{{progress}}%
			</div>
		</div>
	</form>
</mat-dialog-content>

<mat-dialog-actions class="btn-actions">
	<button class="btn btn-primary btn-lg rounded-pill" type="submit" form="form">
		<i class="fas fa-save"></i>
		Guardar
	</button>
</mat-dialog-actions>
